/**
 * The frame the six signed-out pages share (SignIn, SignUp, VerifyEmail,
 * ForgotPassword, ResetPassword, AcceptInvite), spread into Foundation's
 * AuthLayout: `<AuthLayout {...authFrame} title=… description=…>`, the
 * pattern of studio-mothership's AuthGate. It replaced AuthShell (PLAT-367).
 *
 * The brand is the Olytic mark and wordmark AuthShell rendered, linking to
 * `/`. Auth pages render before a session exists, so there is no workspace
 * logo to show; the mark is the static ink file and the wordmark colours are
 * fixed. The aside is the reassurance panel AuthLayout shows beside the form
 * from `lg` up; on a phone it drops away. Its copy is the app's own
 * description (index.html's og:description and meta description).
 */

import { AuthAside } from '@olytic/foundation';
import { Link } from 'react-router-dom';

export const authFrame = {
  brand: (
    <Link
      to="/"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}
    >
      <img
        src="/olytic-mark.svg"
        alt=""
        aria-hidden="true"
        width={28}
        height={28}
        style={{ display: 'block' }}
      />
      <span
        style={{
          fontFamily: "'DM Sans', Inter, system-ui, -apple-system, sans-serif",
          fontWeight: 700,
          fontSize: 20,
          letterSpacing: '0.04em',
          color: '#0F1720',
        }}
      >
        OL<span style={{ color: '#B89149' }}>Y</span>TIC
      </span>
    </Link>
  ),
  aside: (
    <AuthAside
      heading="Chat with the best models, hooked to your team's tools."
      points={[
        'Cloud-hosted, governed connectors to the tools your team already uses.',
        'Per-user permissions and downstream OAuth scoping.',
        'Admin controls baked in.',
      ]}
    />
  ),
};
